import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import { isEmpty } from "lodash";

async function create(data) {
  const response = await http.postData("/persetujuan-marker-site", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function update(id, data) {
  const response = await http.putData(`/persetujuan-marker-site/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http.getData(`/register/${register_id}/persetujuan-marker-site`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function find(id: number) {
  const response = await http.getData(`/persetujuan-marker-site/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function getMasters() {
  const response = await http.getData(`/persetujuan-marker-site/masters`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function autofillFromApb(register_id: string | number) {
  const response = await http.getData(`/register/${register_id}/persetujuan-marker-site/autofill`).catch(err => {
    return Promise.reject(err);
  });
  return response;
}

async function crossCheck(register_id: string | number, params: { sisi?: string; prosedur?: string; icd9cm?: string }) {
  const qs = new URLSearchParams();
  if (params.sisi) qs.append("sisi", params.sisi);
  if (params.prosedur) qs.append("prosedur", params.prosedur);
  if (params.icd9cm) qs.append("icd9cm", params.icd9cm);
  const response = await http.getData(`/register/${register_id}/persetujuan-marker-site/cross-check?${qs.toString()}`).catch(err => {
    return Promise.reject(err);
  });
  return response;
}

async function signDpjp(id: number, data) {
  const response = await http.putData(`/persetujuan-marker-site/${id}/sign-dpjp`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function signSaksiRs(id: number, data) {
  const response = await http.putData(`/persetujuan-marker-site/${id}/sign-saksi-rs`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function markPenyetuju(id: number, data) {
  const response = await http.putData(`/persetujuan-marker-site/${id}/mark-penyetuju`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function markSaksiPasien(id: number, data) {
  const response = await http.putData(`/persetujuan-marker-site/${id}/mark-saksi-pasien`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function submitTimeout(id: number, data) {
  const response = await http.putData(`/persetujuan-marker-site/${id}/submit-timeout`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function destroy(id: number) {
  const response = await http.deleteData(`/persetujuan-marker-site/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  const data = isEmpty(response?.data) ? null : response.data;
  return data;
}

function print(id) {
  window.open(`${http.getAPI()}/persetujuan-marker-site/${id}/pdf`, "_blank");
}

export default {
  create,
  update,
  getByRegister,
  find,
  getMasters,
  autofillFromApb,
  crossCheck,
  signDpjp,
  signSaksiRs,
  markPenyetuju,
  markSaksiPasien,
  submitTimeout,
  destroy,
  print,
};
